import { styled, makeStyles, AppBar } from "@material-ui/core";
import { Linked, useIO, useLinked, useModel } from "@type-r/react";
import { Flex, Loading, Page, TilesList, Columns, Column, Toolbar, SelectSortBy, Button } from "lqx-react";
import * as React from "react";
import { useMemo } from "react";
import { NotificationSubscription } from "../api/notificationSubscription";
import { AddFilter } from "../components/search-bar/search-bar";
import { SortOptions } from "./models/notification-subscriptions-filters";
import { NotificationSubscriptionsStore } from "./models/notification-subscriptions-store";
import { NotificationSubscriptionDialog } from "./notification-subscription-dialog";
import { NotificationSubscriptionsRenderer } from "./notification-subscriptions-renderer";


export const NotificationSubscriptionsPage = () => {
    var classes = useStyles();
    const state = useModel(NotificationSubscriptionsStore);
    const $isReady = useLinked(false);
    const $activeCard: Linked<NotificationSubscription> = useLinked<NotificationSubscription>(null);
    const $editCardId = useLinked<string>(null);
    const $isDialogOpen = useLinked(false);
    const $refreshCounter = useLinked(0);

    useIO(async () => {
        await state.initialize();
        await state.fetchNotificationSubscriptions();
        $isReady.set(true);
    }, [])

    useMemo(async () => {
        if ($isReady.value) {
            $isReady.set(false);
            $activeCard.set(null);
            await state.fetchNotificationSubscriptions();
            $isReady.set(true);
        }
    }, [ state.filter[ '_changeToken' ], $refreshCounter.value ]);

    const addNewRecipient = () => {
        $editCardId.set(null);
        $isDialogOpen.set(true);
    }

    return <>
        <Page maxWidth={ false }
            header={
                <Flex center>
                    <h4 className={ classes.title }>Manage Subscriptions - Email Notifications</h4>
                </Flex>
            }
            top={
                <AppBar position="static" color="secondary">
                    <Toolbar>
                        <StyledFilterBar filter={ state.filter } filterAllPlaceholder="Filter by Email, Subscription Type..." />
                        <SelectSortBy $attr={ state.filter.sortBy.$.attr } $asc={ state.filter.sortBy.$.asc } options={ SortOptions } />

                        <Button
                            style={ { marginLeft: "auto" } }
                            color="primary"
                            onClick={ () => addNewRecipient() }
                        >
                            Add New Recipient
                        </Button>
                    </Toolbar>
                </AppBar>
            }>

            { $isDialogOpen.value && <NotificationSubscriptionDialog key={ $editCardId.value } $isOpen={ $isDialogOpen } notificationSubscriptionId={ $editCardId.value } onSuccess={ () => $refreshCounter.set($refreshCounter.value + 1) } /> }

            { $isReady.value ?
                <Columns style={ { minHeight: 'calc(100% - 4em)' } }>
                    <TilesListColumn>
                        <TilesList
                            items={ state.page.items.models }
                            itemSize={ 100 }
                            renderer={ NotificationSubscriptionsRenderer($activeCard, card => <>
                                <EditButton color="primary" onClick={
                                    evt => {
                                        $editCardId.set(card.id);
                                        $isDialogOpen.set(true);
                                        evt.stopPropagation();
                                    }
                                }>Edit</EditButton>

                            </>) }
                            selected={ undefined }
                        />
                    </TilesListColumn>
                </Columns> : <Loading />
            }
        </Page>
    </>
};

const useStyles = makeStyles({
    title: {
        padding: '20px 0',
        color: '#3d6889',
        fontSize: '24px'
    }
});

const TilesListColumn = styled(Column)({
    minWidth: '500px',
    minHeight: '250px',
});

const StyledFilterBar = styled(AddFilter)({
    width: '650px',
    alignItems: 'center',
    padding: '4px',
});

const EditButton = styled(Button)({
    marginTop: '10px',
    height: '23px',
    borderRadius: '50px',
    padding: '5px, 10px, 5px, 10px',
    fontFamily: 'Montserrat',
    fontSize: '11px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '13px',
    letterSpacing: '0px',
    textAlign: 'center',
    disabled: 'true'
});
